import { css } from 'lit';
import { styles } from '@material/web/menu/internal/menuitem/menu-item-styles.js';
import { IxSelectOption } from './IxSelectOption.js';

export class IxSelectOptionStyled extends IxSelectOption {
  static override styles = [
    styles,
    css`
      ix-icon {
        font-size: 1.5rem;
        display: block;
      }

      [slot='end'] {
        margin-right: 2rem;
      }

      [slot='start'] {
        margin-right: -0.4rem;
      }
    `,
  ];
}

window.customElements.define('ix-select-option', IxSelectOptionStyled);
